import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { MassiveNewRoutingCreateFlags } from './massive-new-routing-create-flags';
import { Router } from '@angular/router';
import { City, Company, Country } from 'src/app/components/shared/models/interface/parametrizacion.interface';
import { ClientPointCompany } from 'src/app/components/massive/models/clientPointCompany.interface';
import { MuRouteDeliveriesData } from 'src/app/components/shared/models/interface/muRouteDeliveriesData.interface';
import { ProcessingData } from 'src/app/components/shared/types/processingData.type';
import { MassiveService } from '../../massive.service';
import { environment } from 'src/environments/environment';
import { MassiveDeliveryPackageNewRequest } from 'src/app/components/shared/api/gen_api_client/routing_pb';
import { vehicleTypes } from '../../models/vehicleTypes.enum';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-massive-new-routing-create',
  templateUrl: './massive-new-routing-create.component.html',
  styleUrls: ['./massive-new-routing-create.component.sass'],
  providers: [DatePipe]
})
export class MassiveNewRoutingCreateComponent extends MuComponent {

  formData: UntypedFormGroup;
  defaultDate: Date;
  serviceDateStartHour: Date;
  serviceDateEndtHour: Date;
  flagList: Flags<MassiveNewRoutingCreateFlags> = new Flags<MassiveNewRoutingCreateFlags>();
  massiveNewRoutingCreateFlags = MassiveNewRoutingCreateFlags;
  vehicleTypes: typeof vehicleTypes = vehicleTypes;
  vehicletypename: string;
  vehicletypeid: number;
  breadCrumbItems: string[];
  selectedCompanyId: number;
  selectedCediId: number;
  actualCountry: Country;
  actualCity: City;
  actualCompany: Company;
  actualCediPoint: ClientPointCompany;
  processingRoute: ProcessingData<MassiveNewRoutingCreateFlags>;
  requestId: number;
  packageList: MassiveDeliveryPackageNewRequest = new MassiveDeliveryPackageNewRequest();
  
  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private massiveService: MassiveService,
    private datePipe: DatePipe
  ) {
    super();
    this.getRouterState();
  }

  muOnInit(): void {
    this.initData();
    this.watchFlags();
  }
  
  /**
   * @description This method is used initialize data used in the component
   * @returns void
   */
  initData() {
    this.defaultDate = new Date();
    this.defaultDate.setDate(this.defaultDate.getDate() + 1);
    this.serviceDateStartHour = new Date();
    this.serviceDateStartHour.setHours(6);
    this.serviceDateStartHour.setMinutes(0);
    this.serviceDateEndtHour = new Date();
    this.serviceDateEndtHour.setHours(18);
    this.serviceDateEndtHour.setMinutes(0);
    this.formData = this.formBuilder.group({
      isInvalidForm: true,
      vehicleType: ['', [Validators.required]],
      serviceDate: [ this.defaultDate , Validators.required],
      serviceDateStartHour: [this.serviceDateStartHour, Validators.required],
      serviceDateEndtHour: [this.serviceDateEndtHour, Validators.required],
    });
    this.processingRoute = new ProcessingData<MassiveNewRoutingCreateFlags>({
      flags: this.flagList,
      errorFlag: MassiveNewRoutingCreateFlags.ROUTING_FAIL,
      showFlag: MassiveNewRoutingCreateFlags.ROUTING_PACKAGES,
      title: 'context.massive.routePackages.title',
      message: 'context.massive.routePackages.message',
      errorTitle: 'context.massive.routePackages.errorTitle',
    });
  }

  /**
   * @description This method is used to watch the flag changes
   * @returns void
   */
  watchFlags(): void {
    this.watch(this.flagList.valueChanges(this.massiveNewRoutingCreateFlags.BACK_TO_DELIVERIES)).subscribe(async flag => {
      this.backToDeliveries();
      flag.toggle();
    });
    this.watch(this.flagList.valueChanges(this.massiveNewRoutingCreateFlags.CONTINUE_TO_CREATE_SERVICE)).subscribe(async flag => {
      this.continueToCreateService();      
      flag.toggle();
    });
  }

  /**
   * @description This method is used to route the services
   * @returns void
   */
  continueToCreateService(): void {
    this.vehicletypename = this.formData.get('vehicleType').value;
    this.vehicletypeid = +this.vehicleTypes[this.formData.get('vehicleType').value];
    this.routeServices();
  }

  /**
   * @description call valhalla routing service
   * @returns void
   */
  routeServices(): void {
    this.processingRoute.begin();
    const startDate = this.datePipe.transform(this.formData.value.serviceDate, 'dd/MM/yyyy');
    const startTime = this.datePipe.transform(this.formData.value.serviceDateStartHour, 'HH:mm');
    const endTime =  this.datePipe.transform(this.formData.value.serviceDateEndtHour, 'HH:mm');
    const streaming = this.massiveService.newRoute(
      this.actualCompany.id, 
      this.actualCity.id, 
      this.actualCediPoint.id, 
      startDate,
      startTime, 
      endTime,
      this.actualCity.geoName,
      this.vehicletypename,
      this.vehicletypeid,
      this.actualCountry.iso2,
      this.packageList
    );
    if (!streaming || typeof streaming.on !== 'function') {
      return environment.guardClause;
    }
    let requestid = 0;
    streaming.on('data', data => {
      if (data.getStatus() === 'TICK') {
        return environment.guardClause;
      }
      if (data.getStatus() === 'END' && data.getResult() === 'ENRUTADO') {
        requestid = data.getRequestid();
        this.processingRoute.end();
        this.router.navigate(['masivos/program', requestid], { state: MuRouteDeliveriesData({ 
          breadcrumb: this.actualCountry?.name + ',' + this.actualCity?.name + ',' + this.actualCompany?.name + ',' + this.actualCediPoint?.name,
          country: this.actualCountry, 
          city: this.actualCity, 
          company: this.actualCompany, 
          cedi: this.actualCediPoint 
        })});
        return environment.guardClause;
      }
      if (data.getStatus() !== 'OK') {
        this.flagList.disable(MassiveNewRoutingCreateFlags.CREATE_SERVICES);
        const msg = data.getResult();
        if (msg.includes('{')) {
          const { type, ...payload } = JSON.parse(msg);
          this.processingRoute.markError(`context.massive.processingExcel.${type}`, payload);
          return environment.guardClause;
        }
        this.processingRoute.markError(data.getResult());
        return environment.guardClause;
      }
      this.processingRoute.init(data.getRecordsquantity());
      this.processingRoute.setProgress(data.getRecordsprocessed());
    });
    streaming.on('error', err => {
      this.processingRoute.markError('context.massive.routePackages.genericErrorMessage');
    });
  }

  /**
   * @description This method is used to start routing services.
   * @returns void
   */
  getRouterState(): void{
    const stateExtras = this.router.getCurrentNavigation().extras.state;
    if ( !stateExtras ) {
      this.router.navigate(['/masivos/new-routing']);
    } else {
      this.actualCediPoint = stateExtras.cedi;
      this.actualCity = stateExtras.city;
      this.actualCompany = stateExtras.company;
      this.actualCountry = stateExtras.country;
      this.packageList = new MassiveDeliveryPackageNewRequest();
      stateExtras.services.forEach(serviceId => {
        this.packageList.addMddeliverypkgid(+serviceId);
      });
    }
  }

  /**
   * @description This method is used to return to shipping table services
   * @returns void
   */
  backToDeliveries():void {
    this.router.navigate(['/masivos/deliveries/'], { state: MuRouteDeliveriesData({ 
      breadcrumb: this.actualCountry?.name + ',' + this.actualCity?.name + ',' + this.actualCompany?.name + ',' + this.actualCediPoint?.name,
      country: this.actualCountry, 
      city: this.actualCity, 
      company: this.actualCompany, 
      cedi: this.actualCediPoint 
    }) });
  }

  muOnDestroy(): void {
    /** */
  }

}
